import { createRoutine } from 'redux-saga-routines';
import { ACTIONS } from '../utils/constants';

const {
  SET_READ_ONLY,
  SET_STUDENT_ID,
  SET_SECTION_ID,
  SET_IMPERSONATOR_EDUCATION_PERIOD,
  SET_IMPERSONATOR_TEACHER_CLASSES,
  SET_IMPERSONATOR_TEACHER_SUBJECTS,
  SET_IMPERSONATOR_TEACHER_NAV,
  SET_IMPERSONATOR_SUBJECT,
  SET_IMPERSONATOR_CURRENT_SUBJECT,
  SET_IS_WELCOME_VIDEO_FIRST_TIME,
} = ACTIONS;

export const setIsReadOnly = (dispatch, isReadOnly) =>
  dispatch({
    type: SET_READ_ONLY,
    payload: { isReadOnly },
  });

export const setStudentId = (dispatch, studentId) =>
  dispatch({
    type: SET_STUDENT_ID,
    payload: { studentId },
  });

export const setSectionId = (dispatch, sectionId) =>
  dispatch({
    type: SET_SECTION_ID,
    payload: { sectionId },
  });

export const setEducationPeriod = (dispatch, educationPeriod) =>
  dispatch({
    type: SET_IMPERSONATOR_EDUCATION_PERIOD,
    payload: { educationPeriod },
  });

export const setTeacherClasses = (dispatch, classes) =>
  dispatch({
    type: SET_IMPERSONATOR_TEACHER_CLASSES,
    payload: { teacherClasses: classes },
  });

export const setTeacherSubjects = (dispatch, subjects) =>
  dispatch({
    type: SET_IMPERSONATOR_TEACHER_SUBJECTS,
    payload: { teacherSubjects: subjects },
  });

export const setIsWelcomeVideoFirstTime = (dispatch, isWelcomeVideoFirstTime) =>
  dispatch({
    type: SET_IS_WELCOME_VIDEO_FIRST_TIME,
    payload: { isWelcomeVideoFirstTime },
  });

export const setTeacherNav = (dispatch, nav) =>
  dispatch({
    type: SET_IMPERSONATOR_TEACHER_NAV,
    payload: { teacherNav: nav },
  });

export const setSubject = (dispatch, subject) =>
  dispatch({
    type: SET_IMPERSONATOR_SUBJECT,
    payload: { subject },
  });

export const setCurrentSubject = (dispatch, subject) =>
  dispatch({
    type: SET_IMPERSONATOR_CURRENT_SUBJECT,
    payload: { currentSubject: subject },
  });

export const doImpersonate = createRoutine('teacher/IMPERSONATE');
export const logoutImpersonate = createRoutine('teacher/IMPERSONATE-logout');
export const refreshImpersonatorAccessToken = createRoutine(
  'teacher/IMPERSONATE-refreshToken',
);
